import { AuthService } from '@lib/services/auth-service.service';
import { EtiquetteService } from '@lib/services/etiquette.service';
import { ReferenceDataService } from '@lib/services/reference-data.service';
import { of } from 'rxjs';
import {
  connaissanceClientAvancementOptions,
  derStatutOptions,
  inOperator,
  myStelliumStatusOptions,
  pieceIdentiteStatutOptions,
  qpiStatutOptions,
  recueilOptions,
  relationSecondaireOptions,
  statutInvestisseurOptions,
} from '../../filtre-investisseur-helper';
import { CompositeFiltreCustomBuilder, FiltreBuilder, ItemFiltreCustomBuilder } from '../filtre-builder.model';
import { MyStelliumStatusFiltreBuilder } from './mystellium-status-builder';

export function getButtonBuilders(
  referenceDataService: ReferenceDataService,
  etiquetteService: EtiquetteService,
  authService: AuthService
): FiltreBuilder[] {
  return [
    new ItemFiltreCustomBuilder(
      'BUTTON',
      'INVESTISSEUR_STATUT',
      'atlasInvestisseur.statutCode',
      inOperator,
      'SelectMultiple',
      of(statutInvestisseurOptions)
    ),
    new ItemFiltreCustomBuilder(
      'BUTTON',
      'CONNAISSANCE_CLIENT_AVANCEMENT_GLOBAL',
      'avancementConnaissanceClientInvestisseur.etatGlobal',
      inOperator,
      'SelectMultiple',
      of(connaissanceClientAvancementOptions)
    ),
    new ItemFiltreCustomBuilder(
      'BUTTON',
      'DER_STATUT',
      'avancementConnaissanceClientInvestisseur.derEtat',
      inOperator,
      'SelectMultiple',
      of(derStatutOptions)
    ),
    new ItemFiltreCustomBuilder(
      'BUTTON',
      'REC_STATUT',
      'avancementConnaissanceClientInvestisseur.recueilEtat',
      inOperator,
      'SelectMultiple',
      of(recueilOptions)
    ),
    new ItemFiltreCustomBuilder(
      'BUTTON',
      'QPI_STATUT',
      'avancementConnaissanceClientInvestisseur.qpiEtat',
      inOperator,
      'SelectMultiple',
      of(qpiStatutOptions)
    ),
    new ItemFiltreCustomBuilder(
      'BUTTON',
      'PIECEIDENTITE_STATUT',
      'avancementConnaissanceClientInvestisseur.cniEtat',
      inOperator,
      'SelectMultiple',
      of(pieceIdentiteStatutOptions)
    ),
    new CompositeFiltreCustomBuilder(
      'BUTTON',
      'RELATION_SECONDAIRE',
      'atlasInvestisseur.investisseurConsultants.some.and',
      'typeRelationInvestisseurConsultantCode',
      inOperator,
      'SelectMultiple',
      of(relationSecondaireOptions),
      [
        { fieldPath: 'actif', operator: 'eq', value: 1 },
        { fieldPath: 'consultantId', operator: 'eq', value: authService.userConsultantId },
      ]
    ),
    new ItemFiltreCustomBuilder(
      'BUTTON',
      'INVESTISSEUR_ORIGINE_CONTACT',
      'atlasInvestisseur.origineContactCode',
      inOperator,
      'SelectMultiple',
      of(referenceDataService.origineContactFilterOptions)
    ),
    new MyStelliumStatusFiltreBuilder(
      'BUTTON',
      'MYSTELLIUM_STATUS',
      'myStelliumInvestisseur.accountStatus',
      inOperator,
      'SelectMultiple',
      of(myStelliumStatusOptions)
    ),
    new ItemFiltreCustomBuilder(
      'BUTTON',
      'INVESTISSEUR_ETIQUETTE',
      'investisseurEtiquette.some.etiquetteId',
      inOperator,
      'SelectMultiple',
      etiquetteService.etiquettesAsSelectOptions()
    ),
  ];
}
